import moment from "moment";

import {
  setIsAffiliate,
  setAffiliateInfo,
  setAffiliateManagement,
  setAffiliateProductivity,
  setAffiliateTransactions,
  setAffiliateAllPrivileges,
} from "../slices/affiliate.slice";
import api from "../../services/api";
import { setUser } from "../slices/user.slice";
import { initLoading, endLoading } from "../slices/generics.slice";

export const getAffiliateAll = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let bodyFormatted = {
      name: body.name.trim(),
      email: body.login.trim(),
      pageSize: body.pageSize,
      pageNumber: body.pageNumber,
      active: body.active === "true" ? true : false,
    };

    body.slug !== "" ? (bodyFormatted.slug = body.slug) : null;
    body.type !== "" ? (bodyFormatted.type = body.type) : null;
    body.privileges !== "" ? (bodyFormatted.privileges = body.privileges) : null;
    body.countryId !== 0 ? (bodyFormatted.countryId = Number(body.countryId)) : null;
    body.subscriptionDate !== ""
      ? (bodyFormatted.subscriptionDate = moment(body.subscriptionDate).format("YYYY-MM-DD"))
      : null;

    try {
      const response = await api.post("/affiliate/get-affiliates-by-filter", bodyFormatted);
      dispatch(setAffiliateManagement(response.data.result));
      return response.data.result.items[0];
    } catch (error) {
      console.log("getAffiliateInfo", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getAffiliateInfo = (id, loading = false) => {
  return async (dispatch, getState) => {
    loading && dispatch(initLoading());

    try {
      const role = getState().userReducer?.user?.role;

      const response = await api.get(`/affiliate/getByUserId/${id}`);
      const items = response.data.result.items[0];

      if (response.data.success && items.active) {
        dispatch(setAffiliateInfo(items));
        return items;
      } else if (response.data.success && (role === "customerService" || role === "companyManager")) {
        dispatch(setAffiliateInfo(items));
      } else {
        dispatch(setAffiliateInfo([]));
      }
    } catch (error) {
      console.log("getAffiliateInfo", error);
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const getAffiliateInfoById = (id, loading = false) => {
  return async (dispatch) => {
    loading && dispatch(initLoading());

    try {
      const response = await api.get(`/affiliate/getById/${id}`);
      return response.data.result.items[0];
    } catch (error) {
      console.log("getAffiliateInfo", error);
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const postSignUpAffiliate = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/affiliate", JSON.stringify(body));
      return response.data.result.items[0];
    } catch (error) {
      console.log("postSignUpAffiliate", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putAffiliate = (body, all = false) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put("/affiliate", JSON.stringify(body));
      if (all) {
        await dispatch(getAffiliateInfo(body?.userId));
        return response.data;
      } else {
        return response.data.result.items[0];
      }
    } catch (error) {
      console.log("putAffiliateInfo", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteAffiliate = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/affiliate/${id}`);
      return response.data.result.items[0];
    } catch (error) {
      console.log("deleteAffiliate", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postAffiliateTax = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      personType: "PF",
      city: params.city?.trim(),
      state: params.state?.trim(),
      taxIdType: params.taxIdType,
      zipcode: params.zipcode?.trim(),
      affiliateId: params.affiliateId,
      fullname: params.fullname?.trim(),
      address1: params.address1?.trim(),
      address2: params.address2?.trim(),
      taxId: params.taxId.replace(/[^0-9]/g, ""),
      countryId: Number(params.whereLiveCountryId),
      // taxClassification: params.taxClassification,
      whereLiveCountryId: Number(params.whereLiveCountryId),
      birthDate: moment(params.birthDate).format("YYYY-MM-DD"),
      citizenshipCountryId: Number(params.citizenshipCountryId),
    };

    try {
      const response = await api.post("/affiliate-tax", JSON.stringify(body));

      if (response.data.success) {
        await dispatch(getAffiliateInfo(params?.userId));

        const result = sessionStorage.getItem("@dataUser");
        const dataUser = JSON.parse(result);

        await dispatch(setUser({ ...dataUser, name: params.fullname?.trim() }));
        if (result) {
          sessionStorage.setItem("@dataUser", JSON.stringify({ ...dataUser, name: params.fullname?.trim() }));
        } else {
          console.log("dataUser inválido");
        }

        return true;
      }
    } catch (error) {
      console.log("postAffiliateTax", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postAffiliatePayment = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/affiliate-payment-method", JSON.stringify(body));

      if (response.data.success) {
        await dispatch(getAffiliateInfo(body?.userId));
        return response.data;
      }
    } catch (error) {
      console.log("postAffiliatePayment", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const createByUserId = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/affiliate/createByUserId", JSON.stringify(body));

      if (response.data.success) {
        await dispatch(getAffiliateInfo(body?.userId));
        await dispatch(getCanBeAffiliate(body?.userId));
        return response.data;
      }
    } catch (error) {
      console.log("postAffiliatePayment", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getCanBeAffiliate = (id) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/affiliate/canBeAffiliateByUserId/${id}`);
      if (response.data.success) {
        dispatch(setIsAffiliate(response.data.result.items));
        return response.data.result.items[0];
      }
    } catch (error) {
      console.log("getCanBeAffiliate", error);
      throw error;
    }
  };
};

export const getDisclosureAffiliate = (lang, groupBy, titleParams = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    const language = lang !== "" ? `&language=${lang}` : "";
    const title = titleParams !== "" ? `&title=${titleParams}` : "";
    const groupByTitle = groupBy !== false ? `&groupByTitle=${groupBy}` : "";

    try {
      const response = await api.get(
        `/affiliates/get-text?pageSize=100&pageNumber=1&textType=AFFILIATEDIVULGATION${language}${groupByTitle}${title}`,
      );

      if (response.data.success) {
        return response.data.result.items;
      }
    } catch (error) {
      console.log("getDisclosureAffiliate", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postDisclosureAffiliate = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/affiliates/add-text", JSON.stringify(body));
      return response.data.success;
    } catch (error) {
      console.log("postDisclosureAffiliate", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putDisclosureAffiliate = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put("/affiliates/edit-text", JSON.stringify(body));
      return response.data.success;
    } catch (error) {
      console.log("putDisclosureAffiliate", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteDisclosureAffiliate = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete("/affiliates/delete-text", { data: body });
      return response.data.success;
    } catch (error) {
      console.log("deleteDisclosureAffiliate", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPerformanceByAffiliateId = (id, startAtParams) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const startAt = moment(startAtParams).format("YYYY-MM-DD");

    try {
      const response = await api.get(`/affiliate/getPerformanceByAffiliateId/${id}/${startAt}`);

      if (response.data.success) {
        dispatch(setAffiliateProductivity(response.data.result.items[0]));
        return response.data.result.items[0];
      }
    } catch (error) {
      console.log("getPerformanceByAffiliateId", error.data);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getTransactionsByFilter = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let body = {
      endAt: params.endAt,
      startAt: params.startAt,
      affiliateId: params.affiliateId,
    };

    if (params.status) body.status = params.status;

    try {
      const response = await api.post(`/affiliate/getTransactionsByFilter`, JSON.stringify(body));

      if (response.data.success) {
        dispatch(setAffiliateTransactions(response.data.result.items));
        return response.data.result.items;
      }
    } catch (error) {
      console.log("getTransactionsByFilter", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putTransactionsSetStatus = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      status: params.status,
      userId: params.userId,
      affiliatePaymentId: params.affiliatePaymentId,
    };

    try {
      const response = await api.put(`/affiliate/transactionsSetStatus`, JSON.stringify(body));

      if (response.data.success) {
        return response.data.success;
      }
    } catch (error) {
      console.log("putTransactionsSetStatus", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPrivilegesRange = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get("/affiliate/get-privileges-range");

      if (response.data.success) {
        dispatch(setAffiliateAllPrivileges(response.data.result.items));
      }
    } catch (error) {
      console.log("getPrivilegesRange", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putPrivilegesRange = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      id: params.id,
      range_min: params.range_min,
      range_max: params.range_max,
      description: params.description,
    };

    try {
      const response = await api.put("/affiliate/set-privileges-range", JSON.stringify(body));

      if (response.data.success) {
        await dispatch(getPrivilegesRange());
        return true;
      }
    } catch (error) {
      console.log("putPrivilegesRange", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postSetPaymentsStatus = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      status: "paid",
      userId: params.userId,
      payments: params.payments,
    };

    try {
      const response = await api.post("/affiliate/setPaymentsStatus", JSON.stringify(body));

      if (response.data.success) {
        return true;
      }
    } catch (error) {
      console.log("postSetPaymentsStatus", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const setAffiliateInStudentPlan = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      affiliateId: Number(params.affiliateId),
      studentPlanPaymentId: params.studentPlanPaymentId,
    };

    try {
      const response = await api.post("/affiliate/setAffiliateInStudentPlan", JSON.stringify(body));

      if (response.data.success) {
        return true;
      }
    } catch (error) {
      console.log("setAffiliateInStudentPlan", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postResendContract = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      affiliateId: Number(id),
    };

    try {
      const response = await api.post("/affiliate/resend-contract", JSON.stringify(body));

      if (response.data.success) {
        return true;
      }
    } catch (error) {
      console.log("postResendContract", error);
    } finally {
      dispatch(endLoading());
    }
  };
};
